
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useTestMode } from "@/hooks/useTestMode";
import { Code, X, Wrench } from "lucide-react";

export function DevButton() {
  const { isTestMode, toggleTestMode, clearGameState, clearEmailOnly } = useTestMode();
  const [isOpen, setIsOpen] = useState(false);
  
  // Only show the button when a special key combination is pressed
  const [isVisible, setIsVisible] = useState(false);
  
  // Add event listener for key combination (Ctrl+Shift+D)
  useState(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.shiftKey && event.key === 'D') {
        setIsVisible(prev => !prev);
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  });
  
  // If not visible, don't render anything
  if (!isVisible) return null;
  
  return (
    <div className="fixed bottom-4 right-4 z-50">
      {isOpen && (
        <div className="bg-black text-white p-3 rounded-lg mb-2 flex flex-col space-y-2">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={clearEmailOnly}
            className="text-white border-white hover:bg-gray-800"
          >
            Clear Email Only
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={clearGameState}
            className="text-white border-white hover:bg-gray-800"
          >
            Reset Game State
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={toggleTestMode}
            className={`${isTestMode ? "bg-green-700" : "bg-transparent"} text-white border-white hover:bg-gray-800`}
          >
            {isTestMode ? "Dev Mode: ON" : "Dev Mode: OFF"}
          </Button>
        </div>
      )}
      <Button
        onClick={() => setIsOpen(!isOpen)}
        size="icon"
        className="h-12 w-12 rounded-full bg-red-600 hover:bg-red-700 shadow-lg border-2 border-white flex items-center justify-center"
      >
        {isOpen ? <X size={20} /> : <Wrench size={20} />}
      </Button>
    </div>
  );
}
